(function () {
  var lists = document.querySelectorAll('[data-iceshock-faq-list]');

  lists.forEach(function (list) {
    var items = list.querySelectorAll('[data-iceshock-faq-item]');

    items.forEach(function (item) {
      var trigger = item.querySelector('[data-iceshock-faq-trigger]');
      var panel = item.querySelector('[data-iceshock-faq-panel]');

      if (item.classList.contains('is-open')) {
        panel.style.maxHeight = panel.scrollHeight + 'px';
      }

      trigger.addEventListener('click', function () {
        var isOpen = item.classList.contains('is-open');

        items.forEach(function (otherItem) {
          if (otherItem !== item && otherItem.classList.contains('is-open')) {
            var otherPanel = otherItem.querySelector('[data-iceshock-faq-panel]');
            var otherTrigger = otherItem.querySelector('[data-iceshock-faq-trigger]');
            otherItem.classList.remove('is-open');
            otherTrigger.setAttribute('aria-expanded', 'false');
            otherPanel.style.maxHeight = '0px';
          }
        });

        if (isOpen) {
          item.classList.remove('is-open');
          trigger.setAttribute('aria-expanded', 'false');
          panel.style.maxHeight = '0px';
        } else {
          item.classList.add('is-open');
          trigger.setAttribute('aria-expanded', 'true');
          panel.style.maxHeight = panel.scrollHeight + 'px';
        }
      });
    });

    window.addEventListener('resize', function () {
      var openItem = list.querySelector('.is-open');
      if (openItem) {
        var openPanel = openItem.querySelector('[data-iceshock-faq-panel]');
        openPanel.style.maxHeight = openPanel.scrollHeight + 'px';
      }
    });
  });
})();